export const WITHDRAW_ROOT_ROUTE = '/account/withdraw'

export const routes = {
  home: `${WITHDRAW_ROOT_ROUTE}`,
  bankAccount: `${WITHDRAW_ROOT_ROUTE}/bank-account`,
  bankAccountLegacy: `/account/bankaccount/edit`,
} as const
